import { format, getQuarter } from "date-fns";
import * as React from "react";
import { Col } from "react-bootstrap";

import { saveQuarterlyFormFilter } from "../../actions/dashboardAction";
import { showPlantListModal } from "../../actions/modalActions";
import { IFilters, IHistory, IQuarterlyForms } from "../../interfaces";
import {
  getFlaggedForms,
  getIndividualFormSummary,
} from "../../services/dashboardService";
import { splitDate } from "../../utils/generalUtils";
import { BarChart } from "../reusableComponents/ChartComponents/BarChart";
import { ChartFooterButtons } from "../reusableComponents/ChartComponents/ChartFooterButtons";
import { CustomToolTip } from "../reusableComponents/CustomToolTip";
import { RDatePicker } from "../reusableComponents/DatePicker";
import { RegionFilter } from "../reusableComponents/RegionFilter";
import { inspectionType, parentInspectionType } from "../../constants/generals";
import { quarters, years, monthsAndYears } from "../../constants/generals";
import { SelectDropdown } from "../reusableComponents/SelectDropdown";

export interface IQuarterlyChartProps {
  onFilter: Function;
  quarterlyForms: IQuarterlyForms;
  filterData: {
    quarterlyFilter: IFilters;
    lineChartFilter: IFilters;
  };
  quarterlySummary: any;
  quarterlyFlaggedForms: any;
  history: IHistory;
  instance: any;
  resetFilters: boolean;
  showFilter: boolean;
  activeDate: Date;
  activeRegion: string;
  monthlyFilterDate: string;
  dailyFilterDate: string;
  quarterlyFlaggedFormCount: string;
}

export interface IQuarterlyChartState {
  regionFilter: string;
  lineChartRegion: string;
  queryString: string;
  quarterlyFilterValue: Date;
  lineChartFilter: Date;
  filteredYear: number;
  filteredQuarter: number;
}

export class QuarterlyChart extends React.PureComponent<
  IQuarterlyChartProps,
  IQuarterlyChartState
> {
  constructor(props: IQuarterlyChartProps) {
    super(props);
    const { quarterlyFilter, lineChartFilter } = props.filterData;
    let initDate = props.activeDate || new Date();
    this.state = {
      quarterlyFilterValue: props.activeDate,
      lineChartFilter: new Date(),
      queryString: "quarterly",
      lineChartRegion: props.filterData.lineChartFilter.region || "",
      regionFilter: quarterlyFilter ? quarterlyFilter.region : "",
      filteredYear: Number(format(initDate, "YYYY")),
      filteredQuarter: getQuarter(initDate),
    };
  }

  componentWillReceiveProps(nextProps: IQuarterlyChartProps) {
    /* const year = new Date(nextProps.activeDate).getFullYear();
        const quarter = getQuarter(nextProps.activeDate); */
    const year = new Date(this.state.quarterlyFilterValue).getFullYear();
    const quarter = getQuarter(this.state.quarterlyFilterValue);
    const queryString = `quarterly?year=${year}&&quarter=${quarter}&&region=${nextProps.activeRegion}`;
    if (this.props.activeDate !== nextProps.activeDate) {
      this.setState({
        queryString,
        quarterlyFilterValue: nextProps.activeDate,
      });
    }
    if (
      this.props.activeRegion !== nextProps.activeRegion &&
      !this.state.regionFilter
    ) {
      this.setState({
        queryString,
        regionFilter: nextProps.activeRegion,
      });
    }
    this.setState({ filteredQuarter: quarter, filteredYear: year });
  }

  renderCustomToolTip = (e) => {
    return <CustomToolTip eventObject={e} />;
  };

  handleClickOnQuarterlyForms = (data, barColor: string) => {
    const { quarterlyForms } = this.props;
    if (barColor.toUpperCase() === "#DBDBDB") {
      //showPlantListModal('dashboard', (quarterlyForms[data.name]['InCompletePlantIds']), 'Incomplete Plants', data.name);
      showPlantListModal(
        "dashboard",
        quarterlyForms[parentInspectionType(data.name)]["InCompletePlantIds"],
        "Incomplete Plants",
        parentInspectionType(data.name)
      );
    } else {
      //showPlantListModal('dashboard', (quarterlyForms[data.name]['CompletePlantIds']), 'Complete Plants', data.name);
      showPlantListModal(
        "dashboard",
        quarterlyForms[parentInspectionType(data.name)]["CompletePlantIds"],
        "Complete Plants",
        parentInspectionType(data.name)
      );
    }
  };

  handleDateFilter = async (date) => {
    this.props.onFilter();

    const { mm, dd, yyyy } = splitDate(date.toString());
    date = new Date(date).toString();
    //const { mm, dd, yyyy } = splitDate(format(date, "YYYY-MM-DD"));
    saveQuarterlyFormFilter(date, this.state.regionFilter);
    await getIndividualFormSummary(
      mm,
      dd,
      yyyy,
      "Quarterly",
      this.state.regionFilter,
      this.props.instance
    );
    await getFlaggedForms(
      "quarterlyForm",
      mm,
      dd,
      yyyy,
      this.state.regionFilter,
      this
    );
    const queryString = `quarterly?year=${yyyy}&&quarter=${getQuarter(
      date
    )}&&region=${this.props.activeRegion}`;
    /*tslint:disable-next-line*/
    const dashboardQueryString = `/dashboard?date=${format(
      this.props.activeDate,
      "YYYY-MM-DD"
    )}&&region=${this.props.activeRegion}&&monthly=${format(
      this.props.monthlyFilterDate,
      "YYYY-MM-DD"
    )}&&daily=${format(
      this.props.dailyFilterDate,
      "YYYY-MM-DD"
    )}&&quarterly=${format(date, "YYYY-MM-DD")}`;
    this.setState({
      quarterlyFilterValue: date,
      queryString,
    });
    this.props.history.push(dashboardQueryString);
    this.props.instance.setState({
      isLoading: false,
    });
  };

  handleRegionFilter = async (formType, region) => {
    this.props.onFilter();
    const { mm, dd, yyyy } = splitDate(
      format(this.state.quarterlyFilterValue, "YYYY-MM-DD")
    );
    await getIndividualFormSummary(mm, dd, yyyy, "Quarterly", region);
    await getFlaggedForms("quarterlyForm", mm, dd, yyyy, region, this);
    this.setState({
      regionFilter: region,
    });
    this.props.instance.setState({
      isLoading: false,
    });
  };

  handleYearFilter = async (value) => {
    this.setState({ filteredYear: Number(value) });
  };
  handleQuarterFilter = async (value) => {
    this.setState({ filteredQuarter: Number(value) });
  };
  filterByQuarter = async () => {
    this.handleDateFilter(
      `${this.state.filteredYear}-${(
        "0" + (this.state.filteredQuarter * 3 - 2).toString()
      ).slice(-2)}-02`.toString()
    );
  };

  render() {
    return (
      <Col
        sm={4}
        xs={12}
        style={styles.pieChartStyle}
        className="quarterly-chart"
      >
        <ChartTitle>Quarterly Form Summary</ChartTitle>
        {this.props.showFilter
          ? [
              <div className="filter-container">
                <SelectDropdown
                  placeholder="Year"
                  onChange={this.handleYearFilter}
                  defaultValue={this.state.filteredYear.toString()}
                  menuItems={years()}
                />
                <SelectDropdown
                  placeholder="Quarter"
                  defaultValue={this.state.filteredQuarter.toString()}
                  onChange={this.handleQuarterFilter}
                  menuItems={quarters()}
                />
                <button
                  className="submit-button"
                  style={{
                    margin: "0 10px",
                    backgroundColor: "#a4bf43",
                    border: "none",
                    height: "32px",
                    padding: "0 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    outline: "none",
                  }}
                  onClick={this.filterByQuarter}
                >
                  {"Submit"}
                </button>
              </div>,
              /*  <Filter
                    key="Date"
                    value={this.state.quarterlyFilterValue}
                    onApply={val => this.handleDateFilter(val)}
                    type="month"
                    children={<RegionFilter
                        selectedValue={this.state.regionFilter}
                        key="region"
                        onChange={this.handleRegionFilter}
                    />}
                />, */
            ]
          : ""}
        <BarChart
          customTooltip={(e) => this.renderCustomToolTip(e)}
          onClick={(e, i) => {
            this.handleClickOnQuarterlyForms(e, i);
          }}
          barColors={["#96D48A", "#DBDBDB"]}
          dataKey={["Complete", "Incomplete"]}
          data={this.props.quarterlySummary}
        />
        <ChartFooterButtons
          flaggedForms={this.props.quarterlyFlaggedFormCount}
          history={this.props.history}
          label="Quarterly"
          redirectTo={this.state.queryString}
          onClickFlaggedForms={() =>
            showPlantListModal(
              "flagged-forms",
              this.props.quarterlyFlaggedForms,
              "Quarterly Flagged Forms",
              "quarterly"
            )
          }
        />
      </Col>
    );
  }
}
function handleYearFilter(value) {
  this.setState({ filterYear: Number(value) });
}
function handleQuarterFilter(value) {
  this.setState({ filterMonth: Number(value) });
}
const Filter = ({ type, onApply, value, children }) => {
  return (
    <div className="filter-container">
      <SelectDropdown
        placeholder="Year"
        onChange={null}
        defaultValue={"2020"}
        menuItems={years()}
      />
      <SelectDropdown
        placeholder="Quarter"
        defaultValue={"1"}
        onChange={null}
        menuItems={quarters()}
      />
      <button
        className="submit-button"
        style={{
          margin: "0 10px",
          backgroundColor: "#a4bf43",
          border: "none",
          height: "32px",
          padding: "0 20px",
          fontSize: "16px",
          borderRadius: "5px",
          outline: "none",
        }}
      >
        {"Submit"}
      </button>
      <RDatePicker
        value={new Date(value)}
        onChange={(e) => onApply(e.toString())}
      />
    </div>
  );
};

const ChartTitle = ({ children }) => {
  return (
    <div className="chart-title" style={{ fontSize: "20px" }}>
      {children}
    </div>
  );
};

const styles = {
  rowStyle: {
    margin: 0,
  },
  colStyle: {
    float: "none",
    display: "inline-block",
  },
  pieChartStyle: {
    float: "none",
    display: "inline-block",
    padding: "50px 0 130px 20px",
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/QuarterlyChart.tsx